export enum CommentActionErrors {
    ListingsCommentsLoading,
    ListingCommentsLoading,
    CommentCreation,
    MarkAsViewed,
    CommentUpdate,
    ListingRemovedError
}